var setImmediateTimeout=function(callback){return window.setTimeout(callback,0)};export default setImmediateTimeout;
//# sourceMappingURL=setImmediateTimeout.js.map